export default __webpack_public_path__ + "icon11f77b5.png";